import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./api/apiSlice";
import { setupListeners } from "@reduxjs/toolkit/query"
import authReducer from "../features/auth/authSlice";

export const store = configureStore({
    reducer:{
        [apiSlice.reducerPath]:apiSlice.reducer,
        auth: authReducer,
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware().concat(apiSlice.middleware),
        // devTools:true
        devTools:false
    })
//if we have several employees opened this and we want redux to refresh the data and show on everytones screen after the update 
setupListeners(store.dispatch)